<template>

	<div :class="{ invisible: !hasChapters }">
		<span v-if="this.$props.showInTab === false" class="font-weight-bold">
			{{ $t("lesson.chapterOverview") }}
		</span>

		<v-card v-if="this.$props.showInTab === false" class="mx-auto mt-3" :tile="true">
			<v-card-text class="text--primary pa-0">
				<v-container v-for="(chapter, i) in this.chapterData" :key="'chapter' + i"
					@click="selectChapter(chapter.position)" class="subtitle-1 clickable py-0 chapter" :class="{ playing: isVideoLesson && chapter.id == currentChapterId }">
					<v-row>
						<v-col :cols="isVideoLesson ? 3 : 1">
							<span v-if="isVideoLesson">{{ convertSeconds(chapter.position) }}</span>
						</v-col>
						<v-col :cols="isVideoLesson ? 8 : 10">
							<span>{{chapter.name}}</span>
						</v-col>
						<v-col cols="1" class="px-0 text-center">
							<span v-if="isVideoLesson" class="chapterIcon material-icons iconSize24">
								{{ chapter.id == currentChapterId ? icons[chapter.icon = 1] : icons[chapter.icon == 1 ? chapter.icon = 2 : chapter.icon] }}
							</span>
							<span v-if="!isVideoLesson" class="chapterIcon material-icons iconSize24">
								{{ icons[3] }}
							</span>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>

		<v-container v-if="this.$props.showInTab === true" class="pa-0">
			<v-row v-for="(chapter, i) in this.chapterData" :key="'chapter' + i"
				@click="selectChapter(chapter.position)" class="subtitle-1 clickable py-0 chapter" :class="{ playing: isVideoLesson && chapter.id == currentChapterId }">
				<v-col v-if="isVideoLesson" cols="4" sm="3">
					<span>{{ convertSeconds(chapter.position) }}</span>
				</v-col>
				<v-col :cols="isVideoLesson ? 6 : 10" :sm="isVideoLesson ? 8 : 11">
					<span>{{chapter.name}}</span>
				</v-col>
				<v-col cols="2" sm="1" class="px-0 text-center">
					<span v-if="isVideoLesson" class="chapterIcon material-icons iconSize24">
						{{ chapter.id == currentChapterId ? icons[chapter.icon = 1] : icons[chapter.icon == 1 ? chapter.icon = 2 : chapter.icon] }}
					</span>
					<span v-if="!isVideoLesson" class="chapterIcon material-icons iconSize24">
						{{ icons[3] }}
					</span>
				</v-col>
			</v-row>
		</v-container>

	</div>

</template>

<script>
import Logger from '@/assets/scripts/logger.js'

export default {
	name: "Chapters",
	props: {
		showInTab: {
			type: Boolean,
			default: false
		},
		videoPosition: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			chapterData : this.$root.lessonData.chapters || [],
			isVideoLesson : this.$root.lessonData.isVideoLesson,
			icons : [ "play_circle_filled", "play_arrow", "check", "bookmark_border" ]
		}
	},
	computed: {
		currentChapterId() {
			var curPos = this.$props.videoPosition,
				chapterId = -1;

			if (!isNaN(curPos)) {
				for (var i=0; i < this.chapterData.length; i++) {
					if (curPos >= this.chapterData[i].position) {
						if (i + 1 == this.chapterData.length || curPos < this.chapterData[i + 1].position) {
							chapterId = this.chapterData[i].id;
							break;
						}
					}
				}
			}

			return chapterId;
		},
		hasChapters() {
			return this.chapterData.length;
		}
	},
	beforeCreate() {
		Logger.log("Chapters.vue beforeCreate");
	},
	created() {
		Logger.log("Chapters.vue created");
	},
	beforeMount() {
		Logger.log("Chapters.vue beforeMount");
	},
	mounted() {
		Logger.log("Chapters.vue mounted");
	},
	beforeUpdate() {
		Logger.log("Chapters.vue beforeUpdate");
	},
	updated() {
		Logger.log("Chapters.vue updated");
	},
	beforeDestroy() {
		Logger.log("Chapters.vue beforeDestroy");
	},
	destroyed() {
		Logger.log("Chapters.vue destroyed");
	},
	methods: {
		selectChapter(position) {
			this.$emit('select', position);
		},
		convertSeconds(val) {
			var sec_num = parseInt(val, 10);
			var hours   = Math.floor(sec_num / 3600);
			var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
			var seconds = sec_num - (hours * 3600) - (minutes * 60);

			//if (hours   < 10) {hours   = "0"+hours;}
			if (minutes < 10) {minutes = "0"+minutes;}
			if (seconds < 10) {seconds = "0"+seconds;}

			if (hours > 0)
				return hours + ':' + minutes + ':' + seconds;

			return minutes + ':' + seconds;
		}
	}
}
</script>

<style lang="scss" scoped>

	@import '@/assets/scss/_definitions.scss';

	.chapterIcon {
		display: inline-flex;
		vertical-align: top;
	}

	.chapter {
		border-bottom: 1px solid rgba(148,154,166,0.10);
		color: rgba($color: $globColPrim, $alpha: 0.6);
		font-weight: 600;

		&:hover {
			color: rgba($color: $globColPrim, $alpha: 1.0);
		}

		&.playing {
			color: rgba($color: $globColPrim, $alpha: 1.0);
		}
	}

</style>
